import { useEffect, useState } from "react";

const SCROLL_KEYS = ["ArrowDown", "PageDown", "End", " ", "Spacebar"];

export const useDelayedReveal = (ms) => {
  const [on, setOn] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches === true);
  useEffect(() => {
    if (on) return;
    const mountedAt = performance.now();
    const show = () => performance.now() - mountedAt > 400 && setOn(true);
    const onScroll = () => window.scrollY > 40 && show();
    const onKey = (e) => SCROLL_KEYS.includes(e.key) && show();
    const t = setTimeout(() => setOn(true), ms);
    window.addEventListener("wheel", show, { passive: true });
    window.addEventListener("touchmove", show, { passive: true });
    window.addEventListener("keydown", onKey);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      clearTimeout(t);
      window.removeEventListener("wheel", show);
      window.removeEventListener("touchmove", show);
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("scroll", onScroll);
    };
  }, [on, ms]);
  return on;
};
